import {takeLatest} from 'redux-saga/effects';
/*CONSTANTS*/
import {
    BOOK_EVENT,
    DELETE_ALERT,
    DELETE_EXTRA_SETTINGS,
    EXTRA_INITIALIZE,
    GET_ACTIVE_EXTRA,
    GET_EVENT,
    GET_EVENTS,
    GET_EXTRA_EVENTS,
    GET_EXTRA_ODDS_EVENTS,
    GET_EXTRA_SETTINGS,
    HIDE_ALERT,
    STORE_EXTRA_INITIALIZE
} from '../../constants/ExtraConstants';
/*SAGAS*/
import {getExtraEventsSaga} from './getExtraEventsSaga';
import {getExtraOddsEventsSaga} from './getExtraOddsEventsSaga';
import {getEventSaga} from "./getEventSaga";
import {bookExtraSaga} from "./bookExtraSaga";
import {getActiveExtraSaga} from "./getActiveExtraSaga";
import {storeSettingSaga} from "./storeSettingSaga";
import {hideAlertSaga} from "./hideAlertSaga";
import {getSettingSaga} from "./getSettingSaga";
import {deleteSettingSaga} from "./deleteSettingSaga";
import {getEventsSaga} from './getEventsSaga';
import {deleteAlertSaga} from './deleteAlert';
import {initializeExtraSaga} from './initializeExtraSaga';

export function* StoreSetting(): Generator {
    // @ts-ignore
    yield takeLatest(STORE_EXTRA_INITIALIZE, storeSettingSaga);
}

export function* GetSetting(): Generator {
    // @ts-ignore
    yield takeLatest(GET_EXTRA_SETTINGS, getSettingSaga);
}

export function* DeleteSetting(): Generator {
    // @ts-ignore
    yield takeLatest(DELETE_EXTRA_SETTINGS, deleteSettingSaga);
}

export function* InitializeExtra(): Generator {
    // @ts-ignore
    yield takeLatest(EXTRA_INITIALIZE, initializeExtraSaga);
}

export function* GetMonitorEvents(): Generator {
    yield takeLatest(GET_EXTRA_EVENTS, getExtraEventsSaga);
}

export function* GetMonitorOddsEvents(): Generator {
    yield takeLatest(GET_EXTRA_ODDS_EVENTS, getExtraOddsEventsSaga);
}

export function* GetEvent(): Generator {
    // @ts-ignore
    yield takeLatest(GET_EVENT, getEventSaga);
}

export function* BookEvent(): Generator {
    // @ts-ignore
    yield takeLatest(BOOK_EVENT, bookExtraSaga);
}

export function* DeleteAlert(): Generator {
    // @ts-ignore
    yield takeLatest(DELETE_ALERT, deleteAlertSaga);
}

export function* GetActiveExtra(): Generator {
    yield takeLatest(GET_ACTIVE_EXTRA, getActiveExtraSaga);
}

export function* HideAlert(): Generator {
    // @ts-ignore
    yield takeLatest(HIDE_ALERT, hideAlertSaga);
}

export function* BookExtra(): Generator {
    // @ts-ignore
    yield takeLatest(BOOK_EVENT, bookExtraSaga);
}

export function* GetEvents(): Generator {
    // @ts-ignore
    yield takeLatest(GET_EVENTS, getEventsSaga);
}


